<div class="gdp-flags-company-table">
  <div class="vox-table">
    <table>
      <thead>
        <tr>
          <td scope="col" translate>internal-facilities.feature-flags.usage-modal.table.cells.name</td>
          <td scope="col" translate>internal-facilities.feature-flags.usage-modal.table.cells.alphaname</td>
          <td scope="col" translate>internal-facilities.feature-flags.usage-modal.table.cells.email</td>
          <td scope="col" translate>internal-facilities.feature-flags.usage-modal.table.cells.actions</td>
        </tr>
      </thead>
      <tbody>
        <ng-container *ngFor="let company of companies; let i = index">
          <tr>
            <td>{{company.name}}</td>
            <td>{{company.alphaname}}</td>
            <td>{{company.email}}</td>
            <td class="dictionary-table__actions">
              <div class="dictionary-table__actions--wrapper">
                <a role="button" [routerLink]="['/dashboard/companies', company.company_id]" target="_blank" class="vox-btn btn btn-warning mr-1"
                [attr.aria-label]="'internal-facilities.feature-flags.usage-modal.table.buttons.details-tooltip' | translate"
                [ngbTooltip]="'internal-facilities.feature-flags.usage-modal.table.buttons.details-tooltip' | translate">
                  {{'internal-facilities.feature-flags.usage-modal.table.buttons.details' | translate}}
                </a>
                <button type="button" (click)="removeCompany(company)" class="vox-btn btn btn-danger"
                [attr.aria-label]="'internal-facilities.feature-flags.usage-modal.table.buttons.disable' | translate"
                [ngbTooltip]="'internal-facilities.feature-flags.usage-modal.table.buttons.disable' | translate">
                  {{'internal-facilities.feature-flags.usage-modal.table.buttons.disable' | translate}}
                </button>
              </div>
            </td>
          </tr>
        </ng-container>
      </tbody>
      <tbody *ngIf="companies.length === 0">
        <tr>
          <td colspan="4" translate>internal-facilities.feature-flags.usage-modal.table.empty</td>
        </tr>
      </tbody>
    </table>
  </div>
</div>